




















import { Component, Vue } from 'vue-property-decorator'
import verifyCodes from './components/AccountsDetails.vue'
import { getLocalStorage } from '../../store/src/utils/index'
@Component({
	components: {
		verifyCodes
	}
})
export default class MobileEmail extends Vue {
	private mobileFlag: string = 'mobile'
	private mobileTitle: string = '手机号：'
	private mobileName: string = ''
	private created () {
		this.mobileName = getLocalStorage('loginerTel', '')
	}
	private validateMobile (value: any, resolve: any) {
		if (!value) {
			(this as any).$fxMessage.error('手机号码不能为空')
			return false
		} else {
			resolve()
		}
	}
	private validatePass (newPassword: any, newPasswordConfirm: any) {
		return new Promise ((resolve: any) => {
			if (newPassword === '') {
				(this as any).$fxMessage.error('请输入密码')
				return false
			} else if (newPasswordConfirm === '') {
				(this as any).$fxMessage.error('请确认密码')
				return false
			} else if (newPasswordConfirm !== newPassword) {
				(this as any).$fxMessage.error('两次填写密码不一致')
				return false
			} else {
				resolve()
			}
		})
	}
	private onModifyPass (newPassWord: any, newPasswordConfirm: any, code: any) {
		(this as any).$confirm('此操作将修改绑定的手机密码，是否继续？', '提示', {
			confirmButtonText: '是',
			cancelButtonText: '否',
			type: 'warning'
		}).then(() => {
			this.validatePass(newPassWord, newPasswordConfirm).then (() => {
				this.onModifyPassHandle(newPassWord, newPasswordConfirm, code)
			})
		})
	}
	private async onModifyPassHandle (newPasswords: any, newPasswordConfirms: any, code: any) {
		const that = (this as any)
		const params = {
			newPassword: newPasswords,
			newPasswordConfirm: newPasswordConfirms,
			vCode: code
		}
		await (this as any).$fxHttp.requestPost({
			url: '/business/modifyPass',
			data: params
		}).then((res: any) => {
			that.$fxMessage.success('修改密码成功')
			that.$refs.passWordDetails.destoryCode()
		})
	}
}
